/* MOREGOSU product saves. Existing v1 product data remains compatible; legacy guides are read-only. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document) {
    root.MGProductSaves = api;
    root.dispatchEvent(new root.CustomEvent("moregosu:product-api-ready"));
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { api.init(root); });
    else api.init(root);
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var KEY = 'moregosu.savedProducts.v1', MAX = 100;
  function fail(message) { throw new Error(message); }
  function path(value, prefix, origin) {
    if (typeof value !== 'string' || !value || /[\\\s]/.test(value)) fail('Invalid product link.');
    var url = new URL(value, origin);
    if (url.origin !== new URL(origin).origin || url.username || url.password || url.search || url.hash || !new RegExp('^/' + prefix + '/[a-zA-Z0-9_-]+(?:/[a-zA-Z0-9_-]+)?/?$').test(url.pathname)) fail('Invalid product link.');
    if (prefix === 'blogs' && url.pathname.split('/').filter(Boolean).length !== 3) fail('An article link is required.');
    if (prefix === 'pages' && url.pathname.split('/').filter(Boolean).length !== 2) fail('A source page is required.');
    return url.pathname;
  }
  function product(value, origin) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) fail('Invalid saved product.');
    if (typeof value.asin !== 'string' || !/^[A-Z0-9]{10}$/.test(value.asin)) fail('Invalid ASIN.');
    var identity = 'amazon.com:' + value.asin;
    if (value.identity !== undefined && value.identity !== identity) fail('Invalid product identity.');
    if (typeof value.title !== 'string' || !value.title.trim() || value.title.length > 240 || /[\u0000-\u001f]/.test(value.title)) fail('Invalid product title.');
    if (typeof value.image !== 'string') fail('Invalid product image.');
    var image = new URL(value.image.startsWith('//') ? 'https:' + value.image : value.image, origin);
    var approvedImage = (image.protocol === 'https:' && image.hostname === 'cdn.shopify.com' && !image.port && image.pathname.startsWith('/s/files/')) || (image.origin === new URL(origin).origin && (image.pathname.startsWith('/cdn/shop/files/') || image.pathname.startsWith('/cdn/shop/articles/')));
    if (!approvedImage || image.username || image.password || image.hash || /[\\\s]/.test(value.image)) fail('Only approved Shopify CDN images are allowed.');
    if (typeof value.imageCaption !== 'string' || !value.imageCaption.trim() || value.imageCaption.length > 300 || /[\u0000-\u001f]/.test(value.imageCaption)) fail('An accurate image caption is required.');
    return { identity: identity, asin: value.asin, title: value.title.trim(), image: image.href, imageCaption: value.imageCaption.trim(), guide: path(value.guide, 'blogs', origin), source: path(value.source, 'pages', origin) };
  }
  function storedProduct(value, origin) {
    var result = product(value, origin);
    if (value.identity !== result.identity || typeof value.savedAt !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value.savedAt) || !Number.isFinite(Date.parse(value.savedAt))) fail('Invalid saved product date or identity.');
    result.savedAt = value.savedAt;
    return result;
  }
  function decode(raw, origin) {
    if (raw === null) return [];
    var parsed;
    try { parsed = JSON.parse(raw); } catch (_) { fail('Saved products could not be read. Existing data was not changed.'); }
    if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.items) || parsed.items.length > MAX) fail('Unsupported saved products data. Existing data was not changed.');
    var seen = new Set();
    return parsed.items.map(function (item) {
      var valid = storedProduct(item, origin);
      if (seen.has(valid.identity)) fail('Duplicate saved product data. Existing data was not changed.');
      seen.add(valid.identity); return valid;
    });
  }
  function createStore(storage, origin, now) {
    now = now || function () { return new Date().toISOString(); };
    function read() { return decode(storage.getItem(KEY), origin); }
    function write(items) { storage.setItem(KEY, JSON.stringify({ version: 1, items: items })); return items; }
    function add(value, restore) {
      var item = restore ? storedProduct(value, origin) : product(value, origin);
      var items = read();
      if (items.some(function (entry) { return entry.identity === item.identity; })) return items;
      if (items.length >= MAX) fail('You can save up to 100 products. Remove one before saving another.');
      if (!restore) item.savedAt = now();
      return write(items.concat([item]));
    }
    function remove(identity) {
      if (!/^amazon\.com:[A-Z0-9]{10}$/.test(identity)) fail('Invalid product identity.');
      var items = read(), removed = items.find(function (item) { return item.identity === identity; });
      if (removed) items = write(items.filter(function (item) { return item.identity !== identity; }));
      return { items: items, removed: removed || null };
    }
    return { read: read, add: function (value) { return add(value, false); }, restore: function (value) { return add(value, true); }, remove: remove };
  }
  function init(win) {
    var doc = win.document;
    if (doc.documentElement.hasAttribute('data-mg-products-ready')) return;
    doc.documentElement.setAttribute('data-mg-products-ready', '');
    var store, undo = null;
    function status(message) {
      var regions = doc.querySelectorAll('[data-mg-products-status]');
      if (!regions.length) {
        var region = doc.createElement('p'); region.setAttribute('data-mg-products-status', '');
        region.className = 'mg-products-live-status';
        region.setAttribute('role', 'status'); region.setAttribute('aria-live', 'polite');
        doc.body.appendChild(region); regions = [region];
      }
      Array.prototype.forEach.call(regions, function (node) { node.textContent = message; });
    }
    function getStore() { if (!store) store = createStore(win.localStorage, win.location.origin); return store; }
    function node(tag, text, attrs) {
      var el = doc.createElement(tag); if (text) el.textContent = text;
      Object.keys(attrs || {}).forEach(function (key) { el.setAttribute(key, attrs[key]); }); return el;
    }
    function render(items) {
      doc.querySelectorAll('[data-mg-saved-header]').forEach(function (el) { el.setAttribute('aria-label', 'Saved products (' + items.length + '). Saved in this browser only.'); el.setAttribute('title', 'Saved products'); Array.prototype.forEach.call(el.childNodes, function (child) { if (child.nodeType === 3 && /^saved guides$/i.test(child.textContent.trim())) child.textContent = 'Saved'; }); });
      var identities = new Set(items.map(function (item) { return item.identity; }));
      doc.querySelectorAll('[data-mg-product-save]').forEach(function (button) {
        var saved = identities.has('amazon.com:' + button.dataset.asin);
        button.disabled = false;
        button.setAttribute('aria-pressed', String(saved));
        if (button.classList.contains('mg-legacy-product-save')) { var label = button.querySelector('span'); if (label) label.textContent = saved ? 'Saved product' : 'Save product'; }
        button.setAttribute('aria-label', (saved ? 'Unsave ' : 'Save ') + (button.dataset.title || 'product'));
      });
      doc.querySelectorAll('[data-mg-products-count], [data-mg-saved-count]').forEach(function (el) { el.textContent = String(items.length); el.hidden = el.hasAttribute('data-mg-saved-hide-zero') && !items.length; });
      doc.querySelectorAll('[data-mg-products-undo]').forEach(function (el) { el.hidden = !undo; });
      doc.querySelectorAll('[data-mg-products-list]').forEach(function (list) {
        list.replaceChildren();
        if (!items.length) { list.appendChild(node('p', 'No saved products yet.')); return; }
        items.slice().reverse().forEach(function (item) {
          var card = node(/^(UL|OL)$/.test(list.tagName) ? 'li' : 'article', '', { 'class': 'mg-shop__card mg-shop__card--product' });
          var link = node('a', '', { href: item.guide, 'class': 'mg-shop__picture' });
          var displayCaption = item.imageCaption.replace(/^Editorial guide illustration, not a product photograph\. /, '');
          var generatedSuffix = ' — Editorial guide illustration, not a product photograph.';
          var suffixAt = displayCaption.lastIndexOf(' — Editorial guide illustration');
          if (suffixAt >= 0) {
            var suffix = displayCaption.slice(suffixAt);
            if (suffix === generatedSuffix || (suffix.endsWith('...') && generatedSuffix.startsWith(suffix.slice(0, -3)))) displayCaption = displayCaption.slice(0, suffixAt);
          }
          link.appendChild(node('img', '', { src: item.image, alt: displayCaption, loading: 'lazy', width: '320', height: '320' }));
          card.appendChild(link);
          if (!list.closest('[data-mg-saved-page]')) {
            card.appendChild(node('p', displayCaption === 'Product image unavailable. This is a neutral placeholder, not a product photograph.' ? 'Image unavailable' : displayCaption, { 'class': 'mg-shop__caption' }));
          }
          var title = node('h3', '', { 'class': 'mg-shop__title' });
          title.appendChild(node('a', item.title, { href: item.guide })); card.appendChild(title);
          var actions = node('div', '', { 'class': 'mg-shop__actions' });
          actions.appendChild(node('button', '×', { type: 'button', 'class': 'mg-shop__heart', 'data-mg-product-remove': item.identity, 'aria-label': 'Remove ' + item.title }));
          actions.appendChild(node('a', 'Amazon', { href: 'https://www.amazon.com/dp/' + item.asin + '?tag=moregosu-20', 'class': 'mg-shop__amazon', rel: 'sponsored nofollow noopener', target: '_blank', 'aria-label': 'View ' + item.title + ' on Amazon (opens in a new tab)' }));
          card.appendChild(actions); list.appendChild(card);
        });
      });
    }
    function sync() { try { render(getStore().read()); } catch (_) { doc.querySelectorAll('[data-mg-product-save]').forEach(function (el) { el.disabled = true; }); doc.querySelectorAll('[data-mg-saved-count]').forEach(function (el) { el.hidden = true; }); status('Saved products are unavailable. Existing data has not been changed.'); } }
    doc.addEventListener('mg:products-refresh', sync);
    doc.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-mg-product-save], [data-mg-product-remove], [data-mg-products-undo]');
      if (!target) return;
      event.preventDefault();
      try {
        var storage = getStore(), items, message;
        if (target.hasAttribute('data-mg-products-undo')) {
          if (!undo) return;
          items = storage.restore(undo); undo = null; message = 'Product restored.';
        } else {
          var isHeart = target.hasAttribute('data-mg-product-save');
          var identity = isHeart ? product(target.dataset, win.location.origin).identity : target.getAttribute('data-mg-product-remove');
          var existing = storage.read().some(function (item) { return item.identity === identity; });
          if (existing) {
            var result = storage.remove(identity); items = result.items; undo = result.removed; message = 'Product removed. You can undo this removal.';
          } else if (isHeart) { items = storage.add(target.dataset); message = 'Product saved in this browser.'; }
          else { items = storage.read(); message = 'Product already removed.'; }
        }
        render(items); status(message);
        if (!doc.contains(target) || target.hidden) {
          var focus = doc.querySelector('[data-mg-products-undo]:not([hidden]), [data-mg-product-remove], [data-mg-products-status]');
          if (focus) { if (!focus.matches('button, a')) focus.setAttribute('tabindex', '-1'); focus.focus(); }
        }
        win.dispatchEvent(new win.CustomEvent('moregosu:products-changed', { detail: { count: items.length } }));
      } catch (error) { status('Could not update saved products. ' + (error.message || 'Please try again.')); }
    });
    win.addEventListener('pageshow', sync);
    doc.addEventListener('shopify:section:load', sync);
    doc.addEventListener('mg:catalogue-ready', sync);
    win.addEventListener('storage', function (event) { if (event.key === KEY || event.key === null) sync(); });
    sync();
  }
  return { KEY: KEY, MAX: MAX, product: product, decode: decode, createStore: createStore, init: init };
}));
